import { PhysicalExamTemplateForm } from "../PhysicalExamTemplateForm";

export interface AddPhysicalExamTemplateProps {}

export const AddPhysicalExamTemplate = () => {
  return <PhysicalExamTemplateForm />;
};
